module.exports = __webpack_public_path__ + "static/img/inis3.59e74b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inis3.png
// module id = jXMS
// module chunks = 1